
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/note_v2/templates/upload"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='noteUpload-icon'></div>\n<div class='noteUpload-message'></div>\n";
},"useData":true});
    }).call(this);
  